<template>
  <b-media
    v-if="showPreview"
    class="d-flex flex-column"
    no-body
  >
    <b-media-aside>
      <b-link>
        <b-button
          variant="primary"
          v-if="isPdfFile(data)"
          href="#0"
          @click="pdf(getFileUrl(data))"
          size="sm"
        >
          Show PDF
        </b-button>
        <b-img
          v-else-if='data'
          rounded
          @click="pdf(getFileUrl(data))"
          @error="onImageError"
          :src="getFileUrl(data)"
          style="width: 200px; height: 150px"
        />
      </b-link>
    </b-media-aside>
  </b-media>
</template>
<script>
import { BMedia, BMediaAside, BLink, BImg, BButton } from "bootstrap-vue";
// import PDFViewer from 'pdf-viewer-vue'

export default {
  props: ["data"],
  data(){
    return{
      imagePath: process.env.VUE_APP_IMAGE_PATH,
      imageLoadFailed: false,
    }
  },
  components: {
    BButton,
    // PDFViewer,
    BMedia,
    BMediaAside,
    BLink,
    BImg,
  },
  computed: {
    showPreview() {
      return this.isValidAttachment(this.data) && !this.imageLoadFailed;
    },
  },
  watch: {
    data() {
      this.imageLoadFailed = false;
    },
  },
  methods: {
    onImageError() {
      this.imageLoadFailed = true;
    },
    isValidAttachment(value) {
      if (value === null || value === undefined) return false;
      if (value instanceof File || value instanceof Blob) return false;
      if (Array.isArray(value)) {
        return value.length > 0 && this.isValidAttachment(value[0]);
      }
      if (typeof value === "object") return false;

      const str = String(value).trim();
      if (!str || str === "[]" || str === "{}" || str === "null" || str === "undefined") {
        return false;
      }
      if (str.includes("no-profile-img")) return false;

      if (/\.(jpe?g|png|gif|webp|bmp|pdf|svg)$/i.test(str)) return true;
      if (/^https?:\/\/.+/i.test(str)) return true;
      if (str.includes("/") && str.length > 3) return true;

      return false;
    },
    pdf(data) {
      window.open(`${data}`);
    },
    isPdfFile(data) {
      if (!data) return false;
      const dataStr = typeof data === 'string' ? data : JSON.stringify(data);
      return dataStr.toLowerCase().includes('.pdf') || dataStr.toLowerCase().includes('pdf');
    },
    getFileUrl(data) {
      if (!data) return '';
      
      // If data is a full URL (starts with http:// or https://), use it as-is
      if (typeof data === 'string' && (data.startsWith('http://') || data.startsWith('https://'))) {
        return data;
      }
      
      // If data already includes the imagePath, use it as-is
      if (typeof data === 'string' && data.includes(this.imagePath)) {
        return data;
      }
      
      // Otherwise, prepend the imagePath
      return this.imagePath + data;
    },
  },
};
</script>
